export default "__VITE_ASSET__BlBnYvZo__"